<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Rechnungslegung
            </h6>
          </div>

          <div class="element-box overflow-hidden">
            <div class="row">
              <!-- 1. Einzelcoaching -->
              <CoachingButton
                  :enabled="companySettings?.privateCoachingEnabled"
                  route-name="billingPrivateCoachingPreviewList"
                  coaching-type="private"
                  label="Einzelcoaching"/>

              <!-- 2. Gruppenmaßnahmen -->
              <CoachingButton
                  :enabled="companySettings?.groupCoachingEnabled"
                  route-name="billingGroupCoachingPreviewList"
                  coaching-type="group"
                  label="Gruppenmaßnahmen"/>

              <!-- 3. Soziotherapie -->
              <CoachingButton
                  :enabled="companySettings?.socioTherapyCoachingEnabled"
                  route-name="billingSocioTherapyCoachingPreviewList"
                  coaching-type="socioTherapy"
                  label="Soziotherapie"/>

              <!-- 4. Betreutes Wohnen -->
              <CoachingButton
                  :enabled="companySettings?.assistedLivingCoachingEnabled"
                  route-name="billingAssistedLivingCoachingPreviewList"
                  coaching-type="assistedLiving"
                  label="Betreutes Wohnen"/>

              <!-- 5. DRV Fallmanagement -->
              <CoachingButton
                  :enabled="companySettings?.caseManagementCoachingEnabled"
                  route-name="billingCaseManagementCoachingPreviewList"
                  coaching-type="caseManagement"
                  label="DRV Fallmanagement"/>

              <!-- 6. Private Weiterbildung -->
              <CoachingButton
                  :enabled="companySettings?.privateLearningCoachingEnabled"
                  route-name="billingPrivateLearningCoachingPreviewList"
                  coaching-type="privateLearning"
                  label="Private Weiterbildung"/>

              <!-- 7. Ausserordentliche -->
              <CoachingButton
                  :enabled="true"
                  route-name="billingSpecialCaseForm"
                  coaching-type="special"
                  label="Ausserordentliche"/>
            </div>
          </div>
        </div>
      </div>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/FormSidebar.vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import {computed} from "vue";
import CoachingButton from "@/components/button/CoachingButton.vue";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

</script>

<style scoped>

</style>